import { api } from './client';

export interface TagOption {
  value: string;
  label: string;
  children?: TagOption[];
}

export interface TagDefinition {
  channel?: 'fb' | 'google' | 'tiktok' | string;
  key: string;
  label: string;
  level: 'campaign' | 'adset' | 'ad';
  display_order?: number;
  sort_order?: number;
  options: TagOption[];
}

export const adTagsApi = {
  getConfig: (site: string, channel?: string, level?: string) =>
    api.get<{ code: number; data: TagDefinition[] }>('/ad-tags/config', {
      params: { site, ...(channel ? { channel } : {}), ...(level ? { level } : {}) },
    }),
};
